<template>
  <v-btn 
        v-bind="$attrs"
        v-on="$listeners"
        icon>
    <Tooltip
      v-if="!reverse"
      color="error"
      :text="'Remover'"
      top
    >
      <v-icon
        small
        color="error"
        @click.stop="openConfirmationDialog = true"
      >
        mdi-delete
      </v-icon>
    </Tooltip>

    <Tooltip
      v-else
      color="warning"
      :text="'Restaurar'"
      top
    >
      <v-icon
        small
        color="warning"
        v-bind="$attrs"
        v-on="$listeners"
        @click.stop="openConfirmationDialog = true"
      >
        mdi-backup-restore
      </v-icon>
    </Tooltip>
    
    <DialogConfirmation 
      v-if="openConfirmationDialog && !reverse" 
      title="Tem a certeza?"  
      type="warning" 
      :opened="openConfirmationDialog" 
      @on-submit="submit" 
      @on-cancel="openConfirmationDialog = false">
        Tem a certeza que quer remover este item?
    </DialogConfirmation>

    <DialogConfirmation 
      v-else
      title="Restaurar item" 
      type="warning" 
      :opened="openConfirmationDialog" 
      @on-submit="submit" 
      @on-cancel="openConfirmationDialog = false">
      Tem a certeza que quer restaurar o item?
    </DialogConfirmation>
  </v-btn>
</template>

<script>
  import DialogConfirmation from '@/components/UI/DialogConfirmation.vue';
  import Tooltip from '@/components/UI/Tooltip.vue';
  export default {
    name: 'uiIconRemove',
    components: {
      DialogConfirmation,
      Tooltip
    },
    props:{
      reverse:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        openConfirmationDialog: false,
      }
    },
    methods: {
      submit() {
        this.openConfirmationDialog = false
        this.$emit('on-submit')
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>